import { useClientConfigProvider } from "@/app/config/client-config-provider";
import Image from "next/image";
import { ReactNode, useEffect, useRef, useState } from "react";
import PrimaryButtonGradient from "../gradientbutton";

export const PopupMenu = ({
  label,
  selectedLabel,
  popUpContent,
  bgClassName,
  popUpClassName = "",
}: {
  label: ReactNode;
  selectedLabel?: ReactNode;
  popUpContent: (closePopup: Function) => ReactNode;
  bgClassName?: string;
  popUpClassName?: string;
}) => {
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const containerRef = useRef<HTMLDivElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);

  function closePopup() {
    setIsFocused(false);
  }

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        containerRef.current &&
        popupRef.current &&
        !containerRef.current.contains(event.target as Node) &&
        !popupRef.current.contains(event.target as Node)
      ) {
        setIsFocused(false);
      }
    }

    // Add event listener on mount
    document.addEventListener("mousedown", handleClickOutside);

    // Remove event listener on cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div>
      {/* Background Blur Effect */}
      <div
        className={isFocused ? `${bgClassName}  transparent-background` : ""}
      />

      {/* Search Input */}
      <div className="search-container">
        <div
          ref={containerRef}
          style={{ cursor: "pointer" }}
          onClick={() => setIsFocused(!isFocused)}
        >
          {isFocused ? selectedLabel ?? label : label}
        </div>

        {/* Search Popup */}
        {isFocused && (
          <div ref={popupRef}>
            <div className={` category-popup ${popUpClassName} `}>
              {popUpContent(closePopup)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
